import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card loginform" }
const _hoisted_2 = { class: "field" }
const _hoisted_3 = { class: "field" }
const _hoisted_4 = { style: {"height":"30px","display":"flex"} }
const _hoisted_5 = { style: {"color":"red","vertical-align":"middle","margin-left":"10px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("h2", null, "Login to Compass", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_InputText, {
          modelValue: _ctx.userName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userName) = $event)),
          modelModifiers: { trim: true },
          onInput: _ctx.formChanged,
          class: _normalizeClass({ 'p-invalid': _ctx.loginFailureMessage != '' })
        }, null, 8, ["modelValue", "onInput", "class"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_InputText, {
          modelValue: _ctx.password,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
          modelModifiers: { trim: true },
          onInput: _ctx.formChanged,
          class: _normalizeClass({ 'p-invalid': _ctx.loginFailureMessage != '' }),
          type: "password"
        }, null, 8, ["modelValue", "onInput", "class"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Button, {
          onClick: _ctx.attemptLogin,
          label: "Login",
          loading: _ctx.isLoading,
          disabled: !_ctx.canSubmit
        }, null, 8, ["onClick", "loading", "disabled"]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.loginFailureMessage), 1)
      ])
    ])
  ]))
}